<template>
  <v-hover>
    <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto">
      <v-card-text id="topic-header" class="headline font-weight-bold white--text text-xs-center"
                   :class="topic.color + ' lighten-3'"
                   style="min-height: 160px;display: flex;align-items: center;justify-content: center;">
        <v-expand-transition v-if="isReadMore">
          <div v-if="hover" class="d-flex transition-fast-in-fast-out teal darken-2 v-card--reveal headline white--text"
               style="height: calc(100% - 64px);margin-bottom: 64px;" @click="gotoTopic()">
            READ MORE
          </div>
        </v-expand-transition>
        <v-btn v-if="topic.isPinned" color="white" dark small absolute top right fab style="top: 10px">
          <v-icon color="red accent-3">fas fa-thumbtack</v-icon>
        </v-btn>
        {{ topic.title }}
      </v-card-text>

      <v-card-actions>
        <v-list-tile class="grow">
          <v-list-tile-avatar color="grey darken-3">
            <v-img class="elevation-6"
                   src="https://graph.facebook.com/1978173195612410/picture"
            ></v-img>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-sub-title class="pt-1">Niishi Kubo</v-list-tile-sub-title>
            <v-list-tile-sub-title class="font-weight-thin caption">{{ topic.createdAt.toDate() | moment("from") }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <div align-center justify-end>
            <v-icon v-if="topic.isLiked" class="mr-1" color="pink" size="20">fas fa-heart</v-icon>
            <v-icon v-else class="mr-1" color="pink" size="20">far fa-heart</v-icon>
            <span class="body-1 font-weight-regular mr-2">{{ topic.likes ? topic.likes.length : 0 }}</span>
            <v-icon class="mr-1" color="grey" size="20">fas fa-share-alt</v-icon>
          </div>
        </v-list-tile>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'TopicDetailPanel',
  props: {
    topic: Object,
    isReadMore: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    gotoTopic() {
      this.$router.push(`/c/${this.topic.communityId}/topic/${this.topic.id}`);
    },
  },
};
</script>

<style scoped>
  .v-list__tile__avatar {
    min-width: 36px!important;
  }
  .v-avatar {
    width: 30px!important;
    height: 30px!important;
  }
  .v-card__text {
    padding: 10px;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .75;
    position: absolute;
    width: 100%;
    z-index: 100;
  }
  .v-note-wrapper{
    z-index: 0;
  }
</style>
